export const SITE = {
  name: 'AV Kamas',
  url: 'https://achatventekamas.com',
  email: 'commande@achatventekamas.com',
  competitor: 'TryAndJudge',
};

export const GAMES = ['DOFUS 3', 'DOFUS RETRO', 'DOFUS TOUCH'];

export const GAME_LABELS = {
  'DOFUS 3': 'Dofus 3 (Unity)',
  'DOFUS RETRO': 'Dofus Rétro',
  'DOFUS TOUCH': 'Dofus Touch',
};

// Liste officielle des serveurs Ankama (septembre 2026).
// buy = prix payé par le client qui achète, sell = prix payé au client qui vend (MAD / million).
// Ces prix servent de secours tant que /api/prices n'a pas répondu.
export const SERVERS = [
  { slug: 'draconiros', name: 'Draconiros', game: 'DOFUS 3', type: 'Monocompte', buy: 9.43, sell: 7.43,
    description: "Serveur monocompte historique de Dofus 3, né de la fusion d'Ilyzaelle et Jahash. Son économie ancienne en fait l'un des serveurs où les Kamas sont les plus recherchés." },
  { slug: 'imagiro', name: 'Imagiro', game: 'DOFUS 3', type: 'Classique', buy: 4.83, sell: 3.89,
    description: "Serveur classique multicompte francophone, proposé par défaut aux nouveaux joueurs. Hôtel des ventes très fourni et économie établie." },
  { slug: 'tal-kasha', name: 'Tal Kasha', game: 'DOFUS 3', type: 'Classique', buy: 5.19, sell: 4.17,
    description: "Serveur classique international où se croisent joueurs francophones, hispanophones, lusophones et anglophones." },
  { slug: 'hell-mina', name: 'Hell Mina', game: 'DOFUS 3', type: 'Classique', buy: 6.96, sell: 5.53,
    description: "Serveur classique historique issu de Merkator et Ush. Économie mature ; depuis septembre 2026, la création de personnages y est réservée aux joueurs déjà présents." },
  { slug: 'orukam', name: 'Orukam', game: 'DOFUS 3', type: 'Classique', buy: 5.07, sell: 4.08,
    description: "Serveur classique historique, héritier de Mériana et Pandore, avec une économie mature et des communautés de longue date." },
  { slug: 'tylezia', name: 'Tylezia', game: 'DOFUS 3', type: 'Classique', buy: 4.83, sell: 3.89,
    description: "Serveur classique historique regroupant Nidas, Furye et Brumen, apprécié des débutants pour son économie stable." },
  { slug: 'brial', name: 'Brial', game: 'DOFUS 3', type: 'Classique', buy: 4.33, sell: 3.51,
    description: "Serveur classique né sous Unity (fusion Brial 1 et 2, mars 2025). Économie jeune où artisans et commerçants trouvent encore leur place." },
  { slug: 'rafal', name: 'Rafal', game: 'DOFUS 3', type: 'Classique', buy: 4.33, sell: 3.51,
    description: "Serveur classique de la génération Unity, issu de la fusion de Rafal 1-2 et Mikhal 1-2 en mars 2025." },
  { slug: 'salar', name: 'Salar', game: 'DOFUS 3', type: 'Classique', buy: 4.33, sell: 3.51,
    description: "Serveur classique de la génération Unity, issu de la fusion de Salar 1-2 et Kourial 1-2 en mars 2025." },
  { slug: 'dakal', name: 'Dakal', game: 'DOFUS 3', type: 'Monocompte', buy: 7.66, sell: 6.07,
    description: "Serveur monocompte regroupant les serveurs pionniers Dakal depuis mars 2025. Jeu social, tout passe par le groupe et le commerce." },
  { slug: 'kourial', name: 'Kourial', game: 'DOFUS 3', type: 'Monocompte', buy: 7.66, sell: 6.07,
    description: "Serveur monocompte né de la fusion de pionniers Dakal en mars 2025, frère de Dakal et Mikhal." },
  { slug: 'mikhal', name: 'Mikhal', game: 'DOFUS 3', type: 'Monocompte', buy: 8.12, sell: 6.42,
    description: "Serveur monocompte issu des pionniers Dakal 1, 4, 6 et 11, à l'économie née sous Unity." },
  { slug: 'ombre', name: 'Ombre', game: 'DOFUS 3', type: 'Épique', buy: 7.00, sell: 5.56,
    description: "Serveur épique à mort définitive en PvM, réservé aux vétérans : chaque Kama y a une vraie valeur." },
  { slug: 'fallanster', name: 'Fallanster', game: 'DOFUS RETRO', type: 'Classique', buy: 4.55, sell: 3.68,
    description: "Serveur Dofus Rétro 1.29 né de la fusion d'Eratz et Henual, les deux serveurs historiques." },
  { slug: 'allisteria', name: 'Allisteria', game: 'DOFUS RETRO', type: 'Classique', buy: 10.47, sell: 8.23,
    description: "Serveur Dofus Rétro issu de Crail et Galgarion, héritiers des premiers serveurs Rétro." },
  { slug: 'boune', name: 'Boune', game: 'DOFUS RETRO', type: 'Monocompte', buy: 32.14, sell: 26.49,
    description: "Serveur Dofus Rétro monocompte : Kamas rares et très valorisés." },
  { slug: 'kelerog', name: 'Kelerog', game: 'DOFUS TOUCH', type: 'Francophone', buy: 36.09, sell: 29.53,
    description: "Serveur Dofus Touch francophone issu d'Oshimo, Herdegrize et Terra Cogita, à l'économie la plus ancienne côté mobile." },
  { slug: 'tiliwan', name: 'Tiliwan', game: 'DOFUS TOUCH', type: 'Francophone', buy: 28.87, sell: 23.98,
    description: "Serveur Dofus Touch francophone à l'économie jeune, née en 2024." },
  { slug: 'blair', name: 'Blair', game: 'DOFUS TOUCH', type: 'International', buy: 15.90, sell: 14.00,
    description: "Serveur Dofus Touch international regroupant Dodge, Grandapan et Brutas." },
  { slug: 'talok', name: 'Talok', game: 'DOFUS TOUCH', type: 'International', buy: 17.14, sell: 14.95,
    description: "Serveur Dofus Touch international issu de Talok et Epsilon." },
];

export const findServer = (slugOrName, list = SERVERS) => {
  const key = String(slugOrName || '').toLowerCase().replace(/\s+/g, '-');
  return list.find(s => s.slug === key || s.name.toLowerCase() === String(slugOrName).toLowerCase());
};

// { 'DOFUS 3': { Draconiros: {...}, ... }, 'DOFUS RETRO': {...}, 'DOFUS TOUCH': {...} }
export const groupServersByGame = (servers) => Object.fromEntries(
  GAMES.map(game => [game, Object.fromEntries(servers.filter(s => s.game === game).map(s => [s.name, s]))])
);

export const formatMad = (n) => `${Number(n).toFixed(2).replace('.', ',')} DH`;
